module.exports = __webpack_public_path__ + "img/resized-APP-0022-2.12bd5357.png";